import { Component } from '@angular/core';
import {  default as getTenantConfig, OptionalValmetDnaConfiguredTag, ValmetDnaSubtitle, ValmetDnaTagConfig } from '~app/shared/map/layer/layer-definitions/T14';

export interface GroupedTableConfig {
  columns: {
    name: string,
    valmetDnaTags: OptionalValmetDnaConfiguredTag[],
  }[],
  groupNames: (string | ValmetDnaSubtitle)[]
}

@Component({
  selector: 'qm-neve-measurements',
  templateUrl: './neve-measurements.component.html',
  styleUrls: ['./neve-measurements.component.scss']
})
export class NeveMeasurementsComponent {
  public mainNetworkTags: (ValmetDnaTagConfig | ValmetDnaSubtitle)[];
  public auxiliaryNetworkConfig: GroupedTableConfig;
  public pressureAndTemperatureConfig: GroupedTableConfig;

  constructor() {
    const { valmetDnaTags } = getTenantConfig().tenantCustomData;

    this.mainNetworkTags = valmetDnaTags.power.mainNetwork;

    // TODO: i18n
    this.auxiliaryNetworkConfig = {
      columns: [{
        name: 'KL-TEHO',
        valmetDnaTags: valmetDnaTags.power.auxiliaryNetwork
      }, {
        name: 'Paine-ero',
        valmetDnaTags: valmetDnaTags.pressure.auxiliaryDelta
      }, {
        name: 'Menolämpö',
        valmetDnaTags: valmetDnaTags.temperature.auxiliaryOut,
      }],
      groupNames: [
        '20NP MUUROLA',
        '30NP YLLÄS',
        '31NP KOLARI',
        '32NP SAVUKOSKI',
      ]
    };

    // TODO: i18n
    this.pressureAndTemperatureConfig = {
      columns: [{
        name: 'Paine-ero',
        valmetDnaTags: valmetDnaTags.pressure.delta
      }, {
        name: 'Menopaine',
        valmetDnaTags: valmetDnaTags.pressure.out,
      }, {
        name: 'Paluupaine',
        valmetDnaTags: valmetDnaTags.pressure.return,
      }, {
        name: 'Menolämpö',
        valmetDnaTags: valmetDnaTags.temperature.out,
      }, {
        name: 'Paluulämpö',
        valmetDnaTags: valmetDnaTags.temperature.return,
      }],
      groupNames: [
        'Suosiola',

        {isSubtitle: true, text: 'Keskusta-Ounasvaara'},
        'Jätkänkynttilä',
        'Apujäähdyttimen pumppua ennen',
        'Apujäähdyttimen pumpun jälkeen',
        'Ounasvaara',
        'Rekimatka',

        // If needed for performance or UI reasons,
        // this is the group that should be moved to a separate tab:
        {isSubtitle: true, text: 'Saarenkylän suunta'},
        'Suutarinkorva',
        'Saarenkylän pumppaamoa ennen',
        'Saarenkylän pumppaamon jälkeen',
        'Santapark',
        'Nivavaaran LK ennen',
        'Nivavaara LK jälkeen',
        'Napapiirin pumppaamoa ennen',
        'Napapiirin pumppaamon jälkeen',
        'Norvatien laitos ennen pumppaamoa',
        'Norvatie paine pumppaamon jälkeen',
        'Lentokenttä',
        'Maunun Matti',

        {isSubtitle: true, text: 'Korkalovaaara'},
        'Evakkotien pumppaamoa ennen',
        'Evakkotien pumppaamon jälkeen',
        'Kaamoskuja',
        'Hilleritie',
        'Kiveliöntie',

        {isSubtitle: true, text: 'Kairatien suunta'},
        'Rakkatie',
        'Raiviotie',
        'Kairatien lämpölaitos',

        {isSubtitle: true, text: 'Alakorkalo-Viirinkangas'},
        'Jäteveden puhdistamo',
        'Rantavitikka',
      ]
    };
  }
}
